import { Utils } from 'mw-style-react';

export const GET_REACTIONS = Utils.createRequestTypes('GET_REACTIONS');
export const CREATE_REACTION = Utils.createRequestTypes('CREATE_REACTION');
export const UPDATE_REACTION = Utils.createRequestTypes('UPDATE_REACTION');
export const DELETE_REACTION = Utils.createRequestTypes('DELETE_REACTION');
export const MARK_AS_READ_REACTION = Utils.createRequestTypes(
  'MARK_AS_READ_REACTION'
);
export const CHANGE_REACTION_ORDER = Utils.createRequestTypes(
  'CHANGE_REACTION_ORDER'
);
export const WS_CREATE_REACTION = 'WS_CREATE_REACTION';
export const WS_UPDATE_REACTION = 'WS_UPDATE_REACTION';
export const WS_DELETE_REACTION = 'WS_DELETE_REACTION';

export const CLEAR_REACTIONS = 'CLEAR_REACTIONS';
export const SET_REACTIONS_REQ_STATUS = 'SET_REACTIONS_REQ_STATUS';

export const _REACTIONS_ORDER_ = 'reactionsOrderDesc';
